module.exports = __webpack_public_path__ + "h5/img/live-logo.768015f6.gif";